import { useState } from "react";
import { useSelector } from "react-redux";
import { useInitiateConversation } from "../../../hooks/messages/useMessages";
import { useNavigate } from "react-router-dom"; 
import { MessageCircle } from "lucide-react";
import MessagePopup from "../../UIFeedback/MessagePopup/MessagePopup";
import { Button } from "../../ui/button";

/**
 * @param {Object} props
 * @param {string} props.userId
 * @param {Object} [props.postData]
 * @param {string} [props.className]
 */
const ChatStartButton = ({ userId, postData, className = "" }) => {
  const navigate = useNavigate();
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const { initiateConversation } = useInitiateConversation(navigate);
  const [showPopup, setShowPopup] = useState(false);

  const handleChatStart = () => {
    if (!isAuthenticated) {
      setShowPopup(true);
      setTimeout(() => setShowPopup(false), 2500);
      return;
    }
    initiateConversation(userId, postData);
  };

  return (
    <div className="relative">
      <Button 
        onClick={handleChatStart} 
        className={`bg-primary hover:bg-primary/90 text-primary-foreground text-xs sm:text-sm 
                    gap-1.5 font-medium ${className}`}
      >
        <MessageCircle className="w-3.5 h-3.5" />
        Contact
      </Button>
      <MessagePopup show={showPopup} message="You must be logged in to send messages." />
    </div>
  );
};

export default ChatStartButton;
